module.exports = __webpack_public_path__ + "assets/830f3e3ad4f046c523295b663ad3fad5.png";